<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>{{ bookmarkData[currentIndex].text }}</span>
      <i
        class="el-icon-close"
        :class="{ close: true }"
        @click="closeBoxCard"
      ></i>
    </div>
    <div class="content-tab">
      <el-tabs v-model="activeName">
        <el-tab-pane
          v-for="(item, index) in bookmarkData"
          :label="item.text"
          :name="item.value"
          :key="item.value"
        >
          <component
            v-if="index == currentIndex"
            :is="bookmarkData[currentIndex].component"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-card>
</template>

<script>
import AiComponent from "@/layout/components/AI/index.vue";
import NotepadComponent from "@/layout/components/Notepad/index.vue";
import CatalogueComponent from "@/layout/components/Catalogue/index.vue";
export default {
  components: {
    AiComponent,
    NotepadComponent,
    CatalogueComponent,
  },
  props: {
    contentId: {
      type: String,
      default: "",
    },
    mountId: {
      type: String,
      default: "",
    },
    // bookmarkData2: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
      activeName: "",
      currentIndex: 0,
      bookmarkData: [
        {
          text: "Catalogue",
          value: "catalogue",
          component: CatalogueComponent,
        },
        { text: "AI knowledge", value: "ai", component: AiComponent },
        { text: "Notepad", value: "notepad", component: NotepadComponent },
      ],
    };
  },
  methods: {
    closeBoxCard() {
      const mountElement = document.getElementById(this.mountId);
      const contentElement = document.getElementById(this.contentId);
      // mountElement.style.width = "100%";
      contentElement.style.width = "0%";
      contentElement.parentNode.childNodes[0].style.width = "calc(100% - 25px)";
      // document.getElementById("bookId").style.right = "0px";
    },
    handleChangeCurrentComponent(event) {
      const activeIndex = event.detail.activeIndex;
      const mountElement = document.getElementById(this.mountId);
      const contentElement = document.getElementById(this.contentId);
      if (mountElement) {
        mountElement.parentNode.style.display = "flex";
        mountElement.parentNode.childNodes[0].style.width = "calc(75% - 25px)";
        // mountElement.style.width = "100%";
        contentElement.style.width = "25%";
        // document.getElementById("bookId").style.right =
        // contentElement.clientWidth + "px";
        // document.getElementById("bookId").style.right = "26.8%";

        // mountElement.style.height = "100%";
        this.currentIndex = activeIndex;
        this.activeName = this.bookmarkData[activeIndex].value;
      }
    },

    addChangeCurrentComponentListener() {
      this.$nextTick().then(() => {
        const contentElement = document.getElementById(this.contentId);
        contentElement.addEventListener(
          "changeCurrentComponent",
          this.handleChangeCurrentComponent
        );
      });
    },
  },
  mounted() {
    this.addChangeCurrentComponentListener();
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  .content-tab {
    height: 100%;
  }
  .close {
    float: right;
    padding: 3px 0;
    cursor: pointer;
  }
  .content-tab {
    flex: 1;
  }

  .text {
    font-size: 14px;
  }
  .item {
    margin-bottom: 18px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both;
  }
}

::v-deep {
  .el-card {
    display: flex;
    flex-direction: column;
  }
  .el-card__body {
    flex-grow: 1;
    padding: 0;
  }
}

::v-deep .el-tabs {
  height: 100%;
  .el-tabs__header {
    display: none;
  }
  .el-tabs__content {
    height: 100%;
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
